import Customer from "../Customer";
import {knob} from "../Configuration";
import Address from "../Address";
import * as _ from 'lodash';

export default class Deliverable {
  getDefaultAddress() {
    let data = new Address({
      [knob.preserveData]: true
    });
    if (!_.isUndefined(this['user'])) {
      if (!_.isUndefined(this['user'].customer)) {
        if (!_.isUndefined(this['user'].customer.addresses)) {
          let defaultAddress = this['user'].customer.addresses.find(s => s.is_default);
          if (!_.isUndefined(defaultAddress)) {
            data = defaultAddress;
            if (!data['phone_arr']) {
              data['phone_arr'] = this['user'].customer.phone;
            } else {
              if (!data['phone_arr']['value']) {
                data['phone_arr'] = this['user'].customer.phone;
              }
            }
          } else {
            if (this['user'].customer.addresses.length > 0) {
              data = this['user'].customer.addresses[0];
            }
          }
        }
      }
    }
    return data;
  }
  getDefaultCustomer() {
    let data = new Customer({
      [knob.preserveData]: true
    });
    if (!_.isUndefined(this['user'])) {
      if (!_.isUndefined(this['user'].customer)) {
        data = this['user'].customer;
      }
    }
    return data;
  }
}

